
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { Toaster } from 'sonner';
import './index.css'; // <-- This is crucial

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <>
      <App />
      <Toaster position="top-center" richColors closeButton />
    </>
  // </React.StrictMode>
);
